import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Utensils } from 'lucide-react';
import { useShoppingListForm } from '../../hooks/shopping/useShoppingListForm';

interface ShoppingListFormProps {
  onSuccess?: () => void;
}

export const ShoppingListForm: React.FC<ShoppingListFormProps> = ({ onSuccess }) => {
  const [name, setName] = useState('');
  const [budget, setBudget] = useState(100);
  const [dishCount, setDishCount] = useState(7);

  const { isSubmitting, error, handleSubmit } = useShoppingListForm(onSuccess);

  const onFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSubmit({ name, budget, dishCount });
  };

  return (
    <form onSubmit={onFormSubmit} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nombre de la lista
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Menú semanal"
          className="w-full px-4 py-2 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
          required
          disabled={isSubmitting}
        />
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
          <DollarSign className="text-orange-500" size={16} />
          Presupuesto máximo: {budget}€
        </label>
        <input
          type="range"
          min={20}
          max={300}
          step={10}
          value={budget}
          onChange={(e) => setBudget(Number(e.target.value))}
          className="w-full h-2 bg-orange-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
          disabled={isSubmitting}
        />
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
          <Utensils className="text-orange-500" size={16} />
          Número de platos: {dishCount}
        </label>
        <input
          type="range"
          min={1}
          max={20}
          value={dishCount}
          onChange={(e) => setDishCount(Number(e.target.value))}
          className="w-full h-2 bg-orange-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
          disabled={isSubmitting}
        />
      </div>

      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}

      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        type="submit"
        className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Creando lista...' : 'Crear lista de la compra'}
      </motion.button>
    </form>
  );
};